import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { constants } from '../shared/constants';
import { LocalStorageService } from './local-storage.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class MyListingsService {
  private appQueryParams?: any;

  constructor(
    private http: HttpClient,
    public localStorageService: LocalStorageService,
    private cookieService: CookieService
  ) {
    if (this.localStorageService.get('appQueryParams')) {
      this.appQueryParams = JSON.parse(
        this.localStorageService.get('appQueryParams')
      );
    }
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  CreateListing(input: any): Observable<any> {
    let url =
      environment.prospektr_sell_backend_base_url +
      constants.prospector_my_listings;
    input['meta'] = this.appQueryParams;
    return this.http
      .post<any>(url, input, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  UpdateListing(id: string, input: any): Observable<any> {
    let url =
      environment.prospektr_sell_backend_base_url +
      constants.prospector_my_listings +
      '/' +
      id;
    input['meta'] = this.appQueryParams;
    return this.http
      .patch<any>(url, input, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetListings(input: any): Observable<any> {
    let url =
      environment.prospektr_sell_backend_base_url +
      constants.prospector_my_listings +
      '?filter=' +
      JSON.stringify(input);
    return this.http
      .get<any>(url, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  notifyListMyHome(input: any): Observable<any> {
    let url =
      environment.prospektr_sell_backend_base_url +
      constants.prospector_list_property;
    return this.http
      .post<any>(url, input, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  getMyHomeDetails(input: any): Observable<any> {
    // let url = 'http://[::1]:3000' + constants.prospector_my_home_details;

    let url =
      environment.prospektr_sell_backend_base_url +
      constants.prospector_my_home_details;
    return this.http
      .post<any>(url, input, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetListingsById(id: string): Observable<any> {
    let url =
      environment.prospektr_sell_backend_base_url +
      constants.prospector_my_listings +
      '/' +
      id;
    return this.http
      .get<any>(url, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  DeleteListingsById(id: string): Observable<any> {
    let url =
      environment.prospektr_sell_backend_base_url +
      constants.prospector_my_listings +
      '/' +
      id;
    return this.http
      .delete<any>(url, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  // Error handling
  errorHandl(error: { error: { message: string }; status: any; message: any }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
